/* eslint-disable no-prototype-builtins */
/* eslint-disable no-constant-condition */
import http from "@/utils/http";
import { getTokenToLocalStorage } from "@/utils/token";
import axios from "axios";

export async function getScriptRepo(params): Promise<any> {
   const res = await http.get("/api/v1/script/repo", {
      params,
   });
   return res;
}

export async function createScriptRepo(data): Promise<any> {
   const res = await http.post("/api/v1/script/repo", data);
   return res;
}

export async function setScriptRepoName(data): Promise<any> {
   const name = data.name
   const res = await http.put(`/api/v1/script/repo/${data.id}`, { name });
   return res;
}

export async function copyScriptRepoFork(data): Promise<any> {
   const res = await http.post(`/api/v1/script/repo/fork`, data);
   return res;
}

export async function deleteScriptRepo(id): Promise<any> {
   const res = await http.delete(`/api/v1/script/repo/${id}`);
   return res;
}

export async function getScriptRepoDetail(id): Promise<any> {
   const res = await http.get(`/api/v1/script/repo/${id}`);
   return res;
}


export async function createScriptRepoWord(data): Promise<any> {
   const res = await http.post(`/api/v1/script/repo/word/create`, data);
   return res;
}

export async function setScriptRepoContent(data): Promise<any> {
   const content = data.content
   const res = await http.put(`/api/v1/script/repo/${data.id}/content`, { content });
   return res;
}

export async function getScriptRepoWord(params): Promise<any> {
   const res = await http.get(`/api/v1/script/repo/word`, { params });
   return res;
}


export async function getScriptRepoArea(params): Promise<any> {
   const res = await http.get(`/api/v1/script/repo/area`, { params });
   return res;
}

function convertParamsToQueryString(params) {
   const queryParts = [];

   for (const key in params) {
      if (params.hasOwnProperty(key)) {
         const value = params[key];

         // 跳过未定义的键值
         if (value === undefined || value === null) {
            continue;
         }

         // 如果值是数组，逐个添加
         if (Array.isArray(value) && value.length > 0) {
            value.forEach((item) => {
               if (item !== undefined && item !== null && item !== "") {
                  queryParts.push(
                     `${encodeURIComponent(key)}=${encodeURIComponent(item)}`,
                  );
               }
            });
         }
         // 如果值是字符串且包含逗号，则拆分并逐个添加
         else if (typeof value === "string" && value.includes(",")) {
            value.split(",").forEach((item) => {
               const trimmedItem = item.trim();
               if (trimmedItem !== "") {
                  queryParts.push(
                     `${encodeURIComponent(key)}=${encodeURIComponent(trimmedItem)}`,
                  );
               }
            });
         }
         // 如果值是非空的字符串或其他类型，直接添加
         else if (value !== "") {
            queryParts.push(
               `${encodeURIComponent(key)}=${encodeURIComponent(value)}`,
            );
         }
         // 如果值是空字符串，添加键但不添加值
         else {
            queryParts.push(`${encodeURIComponent(key)}=`);
         }
      }
   }

   return queryParts.join("&");
}

export async function getScriptRepoAreaConfig(params): Promise<any> {
   const res = await http.get(`/api/v1/script/repo/area/config?${convertParamsToQueryString(params)}`);
   return res;
}

export async function getScriptRepoAreaGenerate(data): Promise<any> {
   const res = await http.post(`/api/v1/script/repo/generate`, data);
   return res;
}

export async function setScriptRepoAudit(data): Promise<any> {
   const res = await http.post(`/api/v1/script/repo/word/audit`, data);
   return res;
}


export async function setScriptRepoReplace(data): Promise<any> {
   const res = await http.post(`/api/v1/script/repo/word`, data);
   return res;
}


export async function deleteScriptRepoWord(data): Promise<any> {
   const res = await http.post(`/api/v1/script/repo/word/delete`, data);
   return res;
}

export async function getRepoWordExport(data): Promise<any> {
   const token = getTokenToLocalStorage();
   const res = await axios.post(`/api/v1/script/repo/word/export`, data, {
      responseType: 'arraybuffer',
      headers: {
         "Token": token
      }
   });
   return res.data;
}


export async function editScriptRepoWord(data): Promise<any> {
   const id = data.id
   delete data.id
   const res = await http.put(`/api/v1/script/repo/word/${id}`, data);
   return res;
}